var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'darkThemeMode': _vm.darkThemeMode, 'lightMode': !_vm.darkThemeMode},attrs:{"id":"app"}},[_c('div',[_c('layout-header'),_c('div',{staticClass:"sdk-docs"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content",attrs:{"id":"mainContent"}},[_c('router-view')],1)])])],1),_c('layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }